module.exports = __webpack_public_path__ + "img/1L1.132cb3af.png";